export default __webpack_public_path__ + "static/media/Novelties.931b8e7c.svg";